module.exports = __webpack_public_path__ + "img/logo-auth.0223d68d.png";